var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1193_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3594 40.3779V48.25H20.9404L10.082 37.2979V10.7207L40.3594 40.3779Z",
    stroke: "#F4C135",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7393 19.5771L49.2314 39.0752L41.4453 39.3047L11.1592 9.60156L37.5967 8.91211L48.7393 19.5771Z",
    stroke: "#E98432",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0723 1.00684C27.9493 0.581746 28.9766 0.731167 29.665 1.39551L29.6699 1.40039L36.0576 7.45117L12.7695 8.05859L27.0723 1.00684Z",
    stroke: "#F4C135",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61914 35.7656L1.39453 28.1543L1.39258 28.1523L1.26758 28.0107C0.678348 27.2852 0.590024 26.2781 1.05566 25.4717L1.0625 25.459L8.61914 11.8037V35.7656Z",
    stroke: "#E98432",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1193_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/Dart.156fcdb248ca3f1139b5ead489f2a8f6.svg";
export { ForwardRef as ReactComponent };